import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import Head from 'components/Head';

import { Layout, Text } from 'ds';

import { SLACK_INTEGRATION_INSTALLED_PATH } from 'routes';

import { getBaseUrl, isDevelop } from 'helpers/environment';
import { completeSlackOAuth } from './requests';

const SlackOAuthCallback: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [redirectIsComplete, setRedirectIsComplete] = useState<boolean>(isDevelop() ? false : true);

  useEffect(() => {
    if (!isDevelop()) return;

    if (window.location.host.includes('ngrok')) {
      const url = new URL('/slack/oauth/callback', getBaseUrl());
      url.search = window.location.search;
      window.location.href = url.href;
    }

    setRedirectIsComplete(true);
  }, []);

  useEffect(() => {
    if (!redirectIsComplete) return;

    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state');

    if (code === null || state === null) {
      setError('Missing code or state from Slack');
      return;
    }

    completeSlackOAuth(code, state)
      .then(response => {
        if (response?.data?.success) {
          history.replace({
            pathname: SLACK_INTEGRATION_INSTALLED_PATH,
            state: {
              appHomeDeepLink: response.data.app_home_deep_link ?? null,
              missingScopes: response.data.missing_scopes ?? []
            }
          });
        } else {
          setError(response?.data?.error ?? 'Slack authorization failed');
        }
      })
      .catch(err => {
        const message = err?.response?.data?.error ?? 'An error occurred during Slack installation';
        setError(message);
      });
  }, [history, location.search, redirectIsComplete]);

  return (
    <Layout
      direction="column"
      justify="center"
      align="center"
      paddingY={80}
      paddingX={24}
      width="100%"
      minHeight="60vh"
    >
      <Head title="Connecting Slack" />
      {error ? (
        <Text size="body-lg" color="red-700">
          {error}
        </Text>
      ) : (
        <Text size="body-lg" color="gray-700">
          Connecting ...
        </Text>
      )}
    </Layout>
  );
};

export default SlackOAuthCallback;
